export default "__VITE_ASSET__04133516__"